import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'replaceAll',
  standalone: false,
})
export class ReplaceAllPipe implements PipeTransform {
  transform(value: string, strToReplace: string, replacementStr: string) {
    if (!value) {
      return '';
    }

    return value.split(strToReplace).join(replacementStr);
  }
}
